import ClientAccountOrderHistoryOrdersTable from './ClientAccountOrderHistoryOrdersTable';

export default ClientAccountOrderHistoryOrdersTable;
